<template>
  <div>
    <b-modal id="success" hide-header hide-footer body-text-variant="dark">
      <template class="bg-success" #modal-title>
        Info
      </template>
      <div class="d-block text-center p-4">
        <h3>Saved Succesfully</h3>
      </div>
      <b-button class="mt-3 px-3 bg-light text-dark float-right" @click="$bvModal.hide('success')">OK</b-button>
    </b-modal>
    <div class="row position-relative mt-3 mb-3">
      <div class="col w-100 text-center">
        <h4>WORKSHOP ARTICLES</h4>
      </div>
    </div>
    <div class="row bg-dark p-3 rounded">
      <div class="w-100 text-center mt-3">
        <div class="col-3 d-inline-block">
          <label for="sku">SKU</label><br>
          <input v-model="newVirtual.sku" class="w-100 input-group-text" type="text" id="sku" required>
        </div>
        <div class="col-2 d-inline-block">
          <label for="ulazna">Entry Price</label>
          <input v-model.number="newVirtual.nabavna" class="w-100 input-group-text" type="number" inputmode="decimal" id="ulazna" required>
        </div>
        <div class="col-2 d-inline-block">
          <label for="izlazna">Price</label>
          <input v-model.number="newVirtual.prodajna" class="w-100 input-group-text" type="number" inputmode="decimal" id="izlazna" required>
        </div>
        <div class="col-1 d-inline-block">
          <label for="kolicina">Quantity</label>
          <input v-model.number="newVirtual.qtt" class="w-100 input-group-text" type="number" id="kolicina" required>
        </div>
        <div class="col-2 d-inline-block">
          <button @click="addVirtual" class="w-100 btn btn-success btn-block">Save</button>
        </div>
        <div v-if="user && user.admin" class="col-2 d-inline-block">
          <button v-if="loading" disabled class="btn btn-light btn-block"><b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="1"></b-icon></button>
          <button @click="sellAllVirtuals" v-else class="btn btn-block btn-primary">Sell All</button>
        </div>
        <div v-else class="col-2 d-inline-block"><span></span></div>
      </div>
    </div>
    <div class="row">
      <div v-if="virtuals.length" class="w-100 mt-5 overflow-hidden rounded">
        <table class="table">
          <thead>
          <tr class="align-middle">
            <th scope="col">#</th>
            <th scope="col">SKU</th>
            <th scope="col">Factory Num</th>
            <th scope="col">Entry Price</th>
            <th scope="col">Price</th>
            <th scope="col">Quantity</th>
            <th scope="col">DATE</th>
            <th scope="col" class="text-center">RETURN</th>
            <th v-if="user && user.admin" scope="col" class="text-center">SELL</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(v, i) of virtuals" v-bind:key="v._id">
            <th class="align-middle" scope="row">{{i + 1}}</th>
            <th class="align-middle" scope="row">{{v.sku}}</th>
            <th class="align-middle" scope="row">{{v.num}}</th>
            <td class="align-middle">{{v.nabavna.toLocaleString('en')}}kr</td>
            <td class="align-middle">{{v.prodajna.toLocaleString('en')}}kr</td>
            <td class="align-middle">{{v.qtt}} kom</td>
            <td class="align-middle">{{moment(v.addedAt).format('DD.MM.YYYY')}}</td>
            <td class="text-center">
              <b-button @click="returnVirtual(v)" class="btn-block">
                <b-icon-arrow-bar-left></b-icon-arrow-bar-left>
              </b-button>
            </td>
            <td v-if="user && user.admin" class="text-center">
              <b-button @click="sellVirtual(v)" class="btn-block">
                <b-icon-arrow-bar-right></b-icon-arrow-bar-right>
              </b-button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="overflow-hidden ml-auto mt-3">
        <table class="table font-weight-bolder float-right">
          <tr>
            <td>TOTAL ORDER VALUE:</td>
            <td class="text-right">{{totalPrice.toFixed(2).toLocaleString('en')}} Kr</td>
          </tr>
          <tr>
            <td>TOTAL PIECES:</td>
            <td class="text-right">{{totalCount}}</td>
          </tr>
        </table>
      </div>
    </div>

  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';

import fixed from '../fixed';

export default {
  data: () => ({
    virtuals: [],
    newVirtual: {},
    totalCount: 0,
    totalPrice: 0,
    loading: false,
    user: null,
    moment,
  }),
  created() {
    this.user = JSON.parse(localStorage.getItem('user'));
  },
  async mounted() {
    await this.getVirtuals();
  },
  methods: {
    async getVirtuals() {
      this.totalCount = 0;
      this.totalPrice = 0;

      try {
        const { data } = await axios.get(
          `${fixed.API_URL}/admin/all-virtuals`,
          { withCredentials: true },
        );
        this.virtuals = data;
        if (data.length) {
          data.forEach((row) => {
            this.totalCount += row.qtt;
            this.totalPrice += (row.nabavna * row.qtt);
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
    },
    async addVirtual() {
      if (!this.newVirtual.sku || !this.newVirtual.nabavna || !this.newVirtual.prodajna || !this.newVirtual.qtt) {
        return;
      }

      if (this.newVirtual.nabavna > this.newVirtual.prodajna) {
        return;
      }
      try {
        await axios.post(`${fixed.API_URL}/admin/add-virtual`, this.newVirtual, { withCredentials: true });
        this.newVirtual = {};
        await this.getVirtuals();
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$toast.warning('you\'re not authorised for this action ✋🏻'); // eslint-disable-line
        } else {
          alert(error); // eslint-disable-line
        }
      }
    },
    async sellAllVirtuals() {
      const sell = confirm(`Export all as sold, sure?`); // eslint-disable-line
      if (!sell) return;

      this.loading = true;
      try {
        // iterate over articles and sell each
        this.virtuals.forEach(async (virtual) => {
          const { sku, qtt } = virtual;
          await axios.put(`${fixed.API_URL}/admin/virtual`, { sku, qtt }, { withCredentials: true });
        });
        // After all done fetch the try to fetch the list again to see if there are any leftovers
        await this.getVirtuals();
      } catch (err) {
        alert(err); // eslint-disable-line
      }
      this.loading = false;
    },
    async sellVirtual(v) {
      const { sku, qtt } = v;
      const prodaj = confirm(`Skini ${sku} sa stanja i zabiljezi prodaju?`); // eslint-disable-line
      if (!prodaj) return;

      try {
        await axios.put(`${fixed.API_URL}/admin/virtual`, { sku, qtt }, { withCredentials: true });
        this.$bvModal.show('success');
        await this.getVirtuals();
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$toast.warning('you\'re not authorised for this action ✋🏻'); // eslint-disable-line
        } else {
          alert(error); // eslint-disable-line
        }
      }
    },
    async returnVirtual(v) {
      const { sku } = v;
      const vrati = confirm(`Vrati ${sku} na stanje i obrisi virtual artikal?`); // eslint-disable-line
      if (!vrati) return;

      try {
        await axios.post(`${fixed.API_URL}/admin/return-virtual`, v, { withCredentials: true });
        this.$bvModal.show('success');
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
      await this.getVirtuals();
    },
  },
};
</script>
